/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_Reason_FireInputs */

const fr_vehicle_action_archive_reason_fire = /** @type {(inputs: Vehicle_Action_Archive_Reason_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incendie`)
};

const en_vehicle_action_archive_reason_fire = /** @type {(inputs: Vehicle_Action_Archive_Reason_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fire`)
};

/**
* | output |
* | --- |
* | "Fire" |
*
* @param {Vehicle_Action_Archive_Reason_FireInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_reason_fire = /** @type {((inputs?: Vehicle_Action_Archive_Reason_FireInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Reason_FireInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_reason_fire(inputs)
	return en_vehicle_action_archive_reason_fire(inputs)
});